import React, { Component } from 'react'
import { Button, Form, Grid, Header, Image, Input, Message, Segment } from 'semantic-ui-react'
import { firebaseAuth, } from '../../../../config/constants.js';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

export default class ArtistLoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: ''
        }
    }

     handleChange = (e) => {
        // log("hx1 >>>>: handleChange clicked");
        // log("hx33 e.target.type:" + e.target.type);
        // log("hx32 e.target.name:" + e.target.name);
        // log("hx34 e.target.value:" + e.target.value);

         let newState = {};
         newState[e.target.name] = e.target.value;
         this.setState(newState);

     }

    handleSubmit = (e) => {
        e.preventDefault();
        console.log("lgx1 ++++++++: handleSubmit");
        console.log(this.state.email);
        console.log(this.state.password);
        console.log(this.state.artistName);

        this.loginUser(this.state.email,this.state.password);

    }

    componentWillMount() {
        document.body.classList.add('login')
    }

    componentWillUnmount() {
        document.body.classList.remove('login')
    }

    loginUser = (email, password) => {
        console.log("px19 ++++++++:loginUser");
        console.log("px20 email:" + email);

        this.setState({ loading: true });
        // let tempFunc = this.checkForUserInUserNode(user.uid);

        firebaseAuth().signInWithEmailAndPassword(email, password)
            //.then(tempFunc(user.uid))
            .then((user) => {
                console.log('logged in:', user.email);
                // this.checkForUserInUserNode(user.uid);

                this.setState({
                    authed: true,
                    // loading: false,
                    user: user,
                    uid: user.uid,
                    loading: false
                });

                history.push('/artistDashboard/'+this.state.artistName);
            })
            .catch((error) => {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                if (errorCode === 'auth/wrong-password') {
                    alert('Wrong password.');
                } else {
                    alert(errorMessage);
                }
                console.log(error);
                this.setState({ loading: false });
            });
    }

    
    render() {
        return (
            <Grid
                textAlign='center'
                style={{ height: '100%' }}
                verticalAlign='middle'
            >
                <Grid.Column style={{ maxWidth: 450 }}>
                    <Header as='h2' color='teal' textAlign='center'>
                        <Image src='/logo.png' />
                        {' '}Log-in to your account
                    </Header>
                    <Form size='large' onSubmit={this.handleSubmit}>
                        <Segment stacked>
                            <Form.Input
                                fluid
                                icon='user'
                                iconPosition='left'
                                placeholder='E-mail address'
                                name="email"
                                onChange = {this.handleChange}
                            />
                            {/* <input  ref={(email) => this.email = email} placeholder="Email"/> */}
                            <Form.Input
                                fluid
                                icon='lock'
                                iconPosition='left'
                                placeholder='Password'
                                type='password'
                                name="password"
                                onChange = {this.handleChange}
                            />
                              <Form.Input
                                fluid
                                icon='music'
                                iconPosition='left'
                                placeholder='Artist Name'
                                name="artistName"
                                onChange = {this.handleChange}
                            />
                            {/* <input type="password" placeholder="Password" ref={(pw) => this.pw = pw} /> */}

                            <Button color='teal' fluid size='large'>Login</Button>
                        </Segment>
                    </Form>
                </Grid.Column>
            </Grid>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/artists/ArtistLoginForm.js